/* src/app/core/error/error.component.scss */
.device-desktop {
  min-width: 1280px;
  overflow-x: auto;
}
.device-tablet {
  min-width: 1133px;
  overflow-x: auto;
}
.device-mobile {
  min-width: 390px;
  overflow-x: auto;
}
.header-h1 {
  font-family: var(--font-family) !important;
  font-weight: 300 !important;
  font-size: 2rem !important;
  color: var(--color-header-name) !important;
}
.header-h2 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1.875rem !important;
  color: var(--color-header-name) !important;
}
.header-h3 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.5rem !important;
  color: var(--color-header-name) !important;
}
.header-h4 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.125rem !important;
  color: var(--color-header-name) !important;
}
.header-h5 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  color: var(--color-header-name) !important;
}
.header-h6 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 0.8125rem !important;
  color: var(--color-header-name) !important;
}
.body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--color-header-name) !important;
}
.small-body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 11.375px !important;
  color: var(--color-header-name) !important;
}
.text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.text-link:hover {
  color: var(--color-hover) !important;
}
.text-link:visited {
  color: var(--color-visited) !important;
}
.small-text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 0.8125rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.small-text-link:hover {
  color: var(--color-hover) !important;
}
.small-text-link:visited {
  color: var(--color-visited) !important;
}
.inline-message .inline-message-content .description,
.inline-message .inline-message-content .title {
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--color-black);
  line-height: 22px;
  letter-spacing: 0px;
}
.inline-message .inline-message-content .title {
  font-weight: 600;
}
:host {
  display: block;
  --font-family: "Open Sans", sans-serif !important;
}
.inline-message {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  border-radius: 12px;
  margin: 25px;
}
.inline-message .inline-message-icon {
  font-size: 24px;
  margin-right: 1rem;
  flex-shrink: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inline-message .inline-message-content .title {
  margin-bottom: 0.25rem;
}
.inline-message .inline-message-content .description {
  color: #475467;
  white-space: pre-line;
}
.inline-message.error {
  background-color: #fff1f3;
  color: #de2437;
  border: 1px solid #de2437;
}
.inline-message.error .inline-message-content .title {
  color: #de2437;
}
:host-context(.device-tablet) .inline-message {
  flex-direction: row;
  padding: 0.75rem;
}
:host-context(.device-tablet) .inline-message .inline-message-icon {
  font-size: 20px;
  margin-right: 0.75rem;
}
:host-context(.device-mobile) .inline-message {
  align-items: flex-start;
  padding: 0.75rem;
}
:host-context(.device-mobile) .inline-message .inline-message-icon {
  font-size: 20px;
  margin-right: 10px;
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=error.component.css.map */
